"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreadcrumbs = void 0;
const react_router_dom_1 = require("react-router-dom");
const utils_1 = require("./utils");
const container_1 = require("./container");
const useBreadcrumbs = () => {
    const routes = (0, container_1.getRouterConfigs)();
    const location = (0, react_router_dom_1.useLocation)();
    return (0, utils_1.createBreadcrumbs)(routes, location);
};
exports.useBreadcrumbs = useBreadcrumbs;
//# sourceMappingURL=use-breadcrumbs.js.map